import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ChevronLeft } from 'lucide-react';
import { Spinner } from '../../../components/ui/spinner';
import { StudySession } from '../../../features/study/study-session';
import { useStudyQueue } from '../../../features/study/use-study-queue';

export const Route = createFileRoute('/_auth/study/$deckId')({
  component: StudyDeckRoute,
  parseParams: (params) => ({ deckId: parseInt(params.deckId, 10) }),
  stringifyParams: (params) => ({ deckId: params.deckId.toString() }),
});

function StudyDeckRoute() {
  const { t } = useTranslation();
  const { deckId } = Route.useParams();
  const { isLoading, isError } = useStudyQueue(deckId);

  return (
    <div className="mx-auto max-w-5xl px-4 py-6 md:px-10 md:py-16">
      <Link
        to="/decks"
        className="mb-10 hidden md:inline-flex items-center gap-2 text-sm font-black uppercase tracking-[0.3em] text-[var(--color-text-muted)] transition-colors duration-500 hover:text-fuchsia-500"
      >
        <ChevronLeft size={12} />
        {t('decks.backToList')}
      </Link>

      {isLoading && (
        <div className="flex justify-center py-16">
          <Spinner size="lg" />
        </div>
      )}

      {isError && (
        <p className="text-sm text-[var(--color-danger)]" role="alert">
          {t('study.session.fetchError')}
        </p>
      )}

      {!isLoading && !isError && <StudySession />}
    </div>
  );
}
